"use client";

import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "@/lib/utils";

export function Tabs({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root className={cn("", className)} {...props} />;
}

export function TabsList({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.List>) {
  return (
    <TabsPrimitive.List
      className={cn(
        "flex items-center gap-0 border-b border-[#ECEFF3]",
        className,
      )}
      {...props}
    />
  );
}

export function TabsTrigger({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        "group relative flex cursor-pointer items-center gap-1.5 border-b-2 border-transparent px-3 py-2 text-[12.5px] font-medium transition-colors duration-150",
        "text-[#92989F] hover:text-[#444746]",
        "data-[state=active]:border-[#713D98] data-[state=active]:text-[#713D98]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#713D98]/40 focus-visible:ring-offset-2",
        className,
      )}
      {...props}
    />
  );
}

export function TabsContent({
  className,
  ...props
}: React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>) {
  return (
    <TabsPrimitive.Content
      className={cn(
        "animate-in fade-in-0 duration-200",
        className,
      )}
      {...props}
    />
  );
}
